<template>
  <div>
    <SGPGraficoComponent
    tipoGrafico="bar"
    :opcoesGrafico="chartOptions"
    :series="dados"
    @sgpGraficoEmit="emissorDados"
    v-bind="$attrs"
    ></SGPGraficoComponent>
  </div>
</template>

<script>
export default {
  name: "GraficoPainelAlarmeComponent",

  props: {
    chartOptions: {
      type: Object
    },
    dados: {
      type: Array
    }
  },

  methods: {
    emissorDados (dados) {
      this.$emit('input', dados)
    }
  }
}
</script>